import React from "react";
import TopBanner from "../../components/TopBanner";
import newsEventlogo from "../../assets/images/newsEventlogo.png";
import {useTranslation} from "react-i18next";
import teamBuilding1 from "../../assets/images/teambuilding1.png";

const NewsEvent: React.FC<any> = () => {
    const {t} = useTranslation();
    return (
        <>
            <div className={'description'}>
                <TopBanner image={newsEventlogo} title={t('header:btn_news_event')}/>
                <div className="company-news-event-content-container mt-12 mb-32">
                    <div id="teambuilding1" className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-7 xl-custom-1280:gap-y-12 4xl-custom:gap-y-28">
                        <div>
                            <a href="#">
                                <img src={teamBuilding1} alt="VarmeegoKickOff2025"/>
                                <div>
                                    <p className="font-secondary text-secondary text-lg pb-1 pt-3">Team Building</p><p className="font-primary text-primary font-bold text-21 pb-1">
                                    2025 Team Building
                                </p>
                                    <p className="font-primary text-lg text-primary pb-1">
                                        Apr, 2025
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div>
                        <ul id="pagination" className="flex justify-center pagination mt-20">
                            <li className="mx-4 self-center"><a className="previous" href="#"></a></li>
                            {/*<li className="text-center cursor-pointer"><a className="pagination-btn text-21 font-primary text-secondary mx-4 active" href="#">1</a></li>*/}
                            {/*<li className="text-center cursor-pointer"><a className="pagination-btn text-21 font-primary text-secondary mx-4" href="#">2</a></li>*/}
                            {/*<li className="text-center cursor-pointer"><a className="pagination-btn text-21 font-primary text-secondary mx-4" href="#">3</a></li>*/}
                            {/*<li className="text-center cursor-pointer"><a className="pagination-btn text-21 font-primary text-secondary mx-4" href="#">4</a></li>*/}
                            {/*<li className="text-center cursor-pointer"><a className="pagination-btn text-21 font-primary text-secondary mx-4" href="#">5</a></li>*/}
                            {/*<li className="mx-4 self-center"><a className="next" href="#"></a></li>*/}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewsEvent;